import { save, openWhatsapp, getMeta, isDesktop, getMessage, isSendMessageToWhatsappEnabled } from '../store.js';

(($) => {

    // Ninja Forms integration is a FormyChat Ultimate feature.
    if (!formychat_vars.is_premium) return;

    async function handleFormSubmission(e, response) {

        /* The `// Submitted Fields` section in the code is iterating over the fields received in the
        form submission response and extracting key-value pairs for each field. It filters out the
        'submit' field and creates an object `fields` containing the key-value pairs of the
        submitted form fields. */
        // console.log('response', response);
        const formId = response.id || 0


        // Submitted Fields.
        const fields = {}
        Object.values(response.response.data.fields).forEach( field => {
            if ( 'submit' !== field.key ) {
                fields[ field.key ] = field.value
            }
        })


        const widget = document.querySelector('[data-whatsapp]');

        if (widget ) {

            // Inside widget.
            const widgetId = widget.dataset.widget;
            if (!widgetId) return;
 
            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if ( !widgetObject ) return;

            const whatsappConfig = { ...(widgetObject.config.whatsapp || {}), widget_id: widgetId };
            const { new_tab, web_version, ninja_message_template, destination_type, group_invite_code } = whatsappConfig;
            const whatsappNumber = destination_type === 'group' && group_invite_code ? group_invite_code : widget.dataset.whatsapp;
            const message = getMessage(ninja_message_template || form.ninja_message_template || '', fields);
            const data = {
                form: 'ninja',
                form_id: formId,
                field: fields,
                meta: getMeta.value,
                widget_id: widgetId,
            }
            

            try {
                const targetOrigin = (typeof formychat_vars !== 'undefined' && formychat_vars?.site?.url)
                    ? new URL(formychat_vars.site.url).origin
                    : '*';
                window.parent.postMessage({formychat_submitted: JSON.parse(JSON.stringify(data))}, targetOrigin);
            } catch (err) {
            }


            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            if (isSendMessageToWhatsappEnabled(whatsappConfig)) {
                openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1, whatsappConfig);
            }

        } else {
            
            const settings = response.response.data.actions.formychat || null;

            if ( !settings ) return;
            

            const { whatsapp_number, message, new_tab, web_version, destination_type, group_invite_code } = settings;
            const to = destination_type === 'group' && group_invite_code ? group_invite_code : whatsapp_number;
            const formattedMessage = getMessage(message, fields);

            const data = {
                form: 'ninja',
                form_id: formId,
                field: fields,
                meta: getMeta.value,
                widget_id: null,
            }

            save(data, to, formattedMessage, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(to, formattedMessage, isDesktop() && web_version == 1, new_tab == 1, settings);
        }
    }

    $(document).on('nfFormSubmitResponse', handleFormSubmission)

})(jQuery)
